export const style = {
  chooseDateFilter: {
    position: "relative",
    borderRadius: "1.8rem",
    backgroundColor: "var(--neutral-100)",
    padding: "0.8rem 1.2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    width: "min-content",
    marginRight: "1.2rem",
    "& > p": {
      marginLeft: "0.4rem",
      color: "var(--orange-500)",
      fontSize: "1.2rem",
      fontWeight: 400,
      width: "10rem",
    },
  },
  dateRangePickerContainer: {
    position: "fixed",
    top: { xs: "15%", sm: "9%", lg: "28%" },
    left: { xs: "2%", lg: "auto" },
    zIndex: "100",
  },
};
